module.exports = __webpack_public_path__ + "static/media/openssidaynus.5c551575.jpeg";